import axios from "axios";

const isDev = process.env.NODE_ENV === "development";
const devApiBase = process.env.REACT_APP_API_BASE_URL || "http://localhost:5600/";

export const axiosInstance = axios.create({
  baseURL: isDev
    ? devApiBase
    : "https://api.elifesavingmedicine.com/",
  withCredentials: true,
});

// Session credentials stay in an HttpOnly cookie. Only the CSRF value lives in memory.
let adminCsrfToken = null;
let sessionRequest = null;
function clearAdminSession() {
  adminCsrfToken = null;
  localStorage.removeItem("adminLoginInfo");
  window.dispatchEvent(new Event("mfw-admin-session-expired"));
}
export async function restoreAdminSession() {
  if (!sessionRequest) {
    sessionRequest = axiosInstance.get("/api/admin/session", { timeout: 15000 })
      .then(response => response.data)
      .finally(() => { sessionRequest = null; });
  }
  return sessionRequest;
}
export async function endAdminSession() {
  try {
    await axiosInstance.post("/api/admin/logout");
  } catch (error) {
    if (error.response?.data?.code !== "AUTH_REQUIRED") throw error;
  }
  clearAdminSession();
}
const adminWritePaths = /^\/api\/(seo(?:\/|$)|ip-access(?:\/|$)|translations(?:\/|$)|admin(?:\/|$)|role(?:\/|$)|medicine(?:\/|$)|dosage(?:\/|$)|seoTags(?:\/|$)|medicineCategory(?:\/|$)|genCompany(?:\/|$)|lang(?:\/|$)|currency(?:\/|$)|adminUrl(?:\/|$)|notification(?:\/|$)|misc(?:\/|$)|multer\/(?:adminProfilePic|medicineImg|medicineVid|singleGenCompanyLogo|temp|files)(?:\/|$))/i;
axiosInstance.interceptors.request.use(async request => {
  const method = (request.method || "get").toLowerCase();
  const url = request.url || "";
  if (!["get", "head", "options"].includes(method) &&
      adminWritePaths.test(url) && !/^\/api\/admin\/login\/?$/i.test(url)) {
    if (!adminCsrfToken) await restoreAdminSession();
    request.headers = { ...request.headers, "X-MFW-CSRF": adminCsrfToken };
  }
  return request;
});
axiosInstance.interceptors.response.use(response => {
  if (/^\/api\/admin\/(?:login|session)\/?$/i.test(response.config.url || "") && response.data.csrfToken) {
    adminCsrfToken = response.data.csrfToken;
  }
  return response;
}, async error => {
  if (error.response?.data?.code === "AUTH_REQUIRED") clearAdminSession();
  if (error.response?.data?.code === "CSRF_INVALID" && !error.config._csrfRetried) {
    adminCsrfToken = null;
    await restoreAdminSession();
    return axiosInstance({ ...error.config, _csrfRetried: true });
  }
  return Promise.reject(error);
});

export const PF = isDev
  ? `${devApiBase.replace(/\/$/, "")}/api/uploads/`
  : "https://api.elifesavingmedicine.com/api/uploads/";
export const PF_backup = isDev
  ? `${devApiBase.replace(/\/$/, "")}/api/backup/`
  : "https://api.elifesavingmedicine.com/api/backup/";



const root = document.documentElement;
export const getSiteColorTheme = async () => {
  let color = "lightblue";
  try {
    const res = await axiosInstance.get("/api/web-settings/", { timeout: 10000 });
    if (res.data && res.data.siteColorTheme)
      color = res.data.siteColorTheme.toString();
  } catch {
    // Theme colours are optional. A failed read must not create an unhandled
    // rejection or prevent the application from showing its recovery surface.
  }
  root.style.setProperty("--get-site-color-theme", color);
  return color;
};

getSiteColorTheme();
